"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Wordpress = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Wordpress_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.245 4.534a7.15 7.15 0 0 1-2.681 9.617l2.185-6.318c.409-1.02.544-1.837.544-2.563 0-.263-.017-.508-.048-.736Zm-5.292.078c.43-.022.819-.068.819-.068.386-.045.34-.612-.046-.59 0 0-1.159.092-1.907.092-.703 0-1.884-.091-1.884-.091-.386-.023-.431.567-.045.59 0 0 .365.045.75.067l1.115 3.055-1.566 4.695-2.606-7.75c.431-.022.82-.068.82-.068.384-.045.339-.612-.047-.59 0 0-1.158.092-1.906.092-.135 0-.293-.004-.46-.009A7.147 7.147 0 0 1 7.966.812c1.863 0 3.559.712 4.832 1.879-.031-.002-.061-.006-.093-.006-.703 0-1.202.612-1.202 1.27 0 .59.34 1.088.703 1.678.272.476.59 1.088.59 1.973 0 .612-.236 1.323-.544 2.313l-.714 2.384-2.586-7.69Zm-.986 10.51a7.15 7.15 0 0 1-2.021-.291l2.147-6.238 2.199 6.025a.674.674 0 0 0 .051.098 7.14 7.14 0 0 1-2.376.406ZM.812 7.967c0-1.037.223-2.022.62-2.912l3.413 9.351a7.155 7.155 0 0 1-4.033-6.44ZM7.967.009C3.58.01.01 3.58.01 7.967s3.57 7.958 7.958 7.958 7.958-3.57 7.958-7.958S12.355.009 7.967.009Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Wordpress_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Wordpress;
exports["default"] = _default;